module.exports = __webpack_public_path__ + "img/warn_01.cc5e6e93.png";